<template>
    <div id="app">
        <div class="align-items-center p-3 px-md-4 mb-3 bg-white border-bottom shadow-sm text-center">
                <img alt="Hecht logo" src="./assets/logo.svg">
        </div>

        <div class="container">
            <div class="row">
                <div class="col-lg" style="margin:0 auto">
                    <Index/>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import Index from './components/Index.vue'

    export default {
        name: 'app',
        components: {
            Index
        }
    }
</script>

